import KycVerification from './kyc-verification';

export default KycVerification;
